"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var tools_1 = require("../utils/tools");
var NAME = 'sup';
var Sup = /** @class */ (function (_super) {
    __extends(Sup, _super);
    function Sup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'sup'; };
        _this.excludes = 'sub';
        _this.parseDOM = [{ tag: 'sup', priority: 25 }];
        return _this;
    }
    return Sup;
}(core_utilities_1.Inline));
exports.Sup = Sup;
var SupController = /** @class */ (function (_super) {
    __extends(SupController, _super);
    function SupController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'sup',
            tooltip: 'sup'
        };
        _this.disable = function (editor) {
            return tools_1.checkMarkDisable(editor.view, NAME);
        };
        return _this;
    }
    return SupController;
}(core_utilities_1.SylController));
exports.SupController = SupController;
var SupPlugin = /** @class */ (function (_super) {
    __extends(SupPlugin, _super);
    function SupPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = SupController;
        _this.Schema = Sup;
        return _this;
    }
    return SupPlugin;
}(core_utilities_1.SylPlugin));
exports.SupPlugin = SupPlugin;
//# sourceMappingURL=sup.js.map